import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector   : 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls  : ['./confirm-dialog.component.scss']
})
export class FuseConfirmDialogComponent implements OnInit
{
    public confirmMessage: string;

    constructor(public dialogRef: MatDialogRef<FuseConfirmDialogComponent>)
    {
    }

    ngOnInit()
    {
    }

}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/core/components/confirm-dialog/confirm-dialog.component.ts